import React from "react";
import { Container, Col, Row, Image } from "react-bootstrap";
import ForThoseWhoServeUs from "./ForThoseWhoServeUs";
import ImportantCBConcierge from "./ImportantCBConcierge";
import HowItWorks from "./HowItWorks";
import { Helmet } from "react-helmet";
const DiamondElite = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Diamond Elite Program</title>
      </Helmet>
      <div className="cbr_Ddiamond_eliye_banner">
        <Container>
          <Row>
            <Col md={12} sm={12} lg={8} className="text-center m-auto">
              <div className="cbr_refer_titel">
                <h1 className="text-white">Diamond Elite Program</h1>
                <p>
                  At <span>CULTURED BRILLIANCE,</span> we love ALL of our
                  customers. But there are <br></br>
                  SOME who deserve the extra mile, because they walk it every
                  day FOR US.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ForThoseWhoServeUs />
      <ImportantCBConcierge />
      <HowItWorks />
    </>
  );
};

export default DiamondElite;
